"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingsHttpService = void 0;
const date_fns_1 = require("date-fns");
const delete_many_1 = require("../../types/accountings/delete-many");
const get_by_id_with_slots_1 = require("../../types/accountings/get-by-id-with-slots");
const get_doctolib_import_1 = require("../../types/accountings/get-doctolib-import");
const get_list_1 = require("../../types/accountings/get-list");
const import_doctolib_csv_1 = require("../../types/accountings/import-doctolib-csv");
const import_doctolib_csv_dazz_1 = require("../../types/accountings/import-doctolib-csv-dazz");
const set_paid_1 = require("../../types/accountings/set-paid");
const http_service_1 = require("../http.service");
class AccountingsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/accountings`);
    }
    getList(payload) {
        const params = {
            ...payload,
            from: payload.from ? (0, date_fns_1.format)(payload.from, 'yyyy-MM-dd') : null,
            to: payload.to ? (0, date_fns_1.format)(payload.to, 'yyyy-MM-dd') : null,
        };
        return this.getEntityList('', {
            params,
            schema: get_list_1.getAccountingsListApiResponseSchema,
        });
    }
    getByIdWithSlots(id) {
        return this.getEntity(`${id}/with-slots`, {
            schema: get_by_id_with_slots_1.getAccountingByIdWithSlotsApiResponseSchema,
        });
    }
    importDoctolibCsv(payload) {
        return this.postEntityList('import-doctolib-csv', {
            body: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            schema: import_doctolib_csv_1.getAccountingImportDoctolibCsvApiResponseSchema,
        });
    }
    async importDoctolibCsvDazz(payload) {
        const body = {
            officeId: payload.officeId,
            doctorAttendingId: payload.doctorAttendingId,
            doctolibFile: payload.doctolibFile,
        };
        if (payload.manualResolutions !== undefined) {
            body.manualResolutions = Array.isArray(payload.manualResolutions)
                ? JSON.stringify(payload.manualResolutions)
                : payload.manualResolutions;
        }
        const url = this.getApiUrlOf('import-doctolib-csv-dazz');
        const { data } = await this.fetch(url, {
            method: 'POST',
            body,
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        const response = import_doctolib_csv_dazz_1.importAccountingDoctolibCsvDazzApiResponseSchema.parse(data);
        return { response };
    }
    exportDoctolibCsv(accountingId) {
        const url = this.getApiUrlOf(`${accountingId}/export-doctolib-csv`);
        return this.fetch(url, {
            method: 'GET',
            transformTo: 'blob',
        });
    }
    exportTransferOrder(payload) {
        const url = this.getApiUrlOf(`/export-transfer-order`);
        const body = {
            officeIds: payload.officeIds,
            doctorAttendingIds: payload.doctorAttendingIds,
            from: payload.from ? (0, date_fns_1.format)(payload.from, 'yyyy-MM-dd') : null,
            to: payload.to ? (0, date_fns_1.format)(payload.to, 'yyyy-MM-dd') : null,
        };
        return this.fetch(url, {
            method: 'POST',
            body,
            transformTo: 'blob',
        });
    }
    async getDoctolibImport(id) {
        const url = this.getApiUrlOf(`doctolib-imports/${id}`);
        const { data } = await this.fetch(url, {
            method: 'GET',
            transformTo: 'json',
        });
        return get_doctolib_import_1.getDoctolibImportApiResponseSchema.parse(data);
    }
    deleteByIds(payload) {
        return this.delete('', {
            body: payload,
            schema: delete_many_1.deleteAccountingsManyApiResponseSchema,
        });
    }
    async setPaid(id, payload) {
        const url = this.getApiUrlOf(`${id}/paid`);
        const { data } = await this.fetch(url, {
            method: 'PATCH',
            body: payload,
        });
        return set_paid_1.setAccountingPaidApiResponseSchema.parse(data);
    }
}
exports.AccountingsHttpService = AccountingsHttpService;
